<template>
  <span v-if="exclusoes">
    <v-tooltip bottom>
      <template v-slot:activator="{ on, attrs }">
        <v-icon color="error" dark v-bind="attrs" v-on="on"> mdi-alert </v-icon>
      </template>
      <span>Possui {{ exclusoes }} solicitação de exclusão</span>
    </v-tooltip>
  </span>
</template>
<script>
export default {
  name: "ETooltipExclusao",
  props: {
    exclusoes: {
      type: Number,
    },
  },
};
</script>
